import { render } from "./logoutRefresh.vue?vue&type=template&id=47326084"
import script from "./logoutRefresh.vue?vue&type=script&lang=js"
export * from "./logoutRefresh.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__